export function formatAmount(value, decimals = 2, thousandsSeparator = '.', decimalSeparator = ',') {
  if (value === null || value === undefined || value === '') return '';

  const number = Number(value);
  if (Number.isNaN(number)) return '';

  const decimalCount = Math.max(0, Number(decimals) || 0);
  const fixed = number.toFixed(decimalCount);
  const parts = fixed.split('.');

  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);

  if (decimalCount <= 0) return parts[0];

  const decimalPart = (parts[1] || '').replace(/0+$/, '');
  return decimalPart ? `${parts[0]}${decimalSeparator}${decimalPart}` : parts[0];
}

export function formatRupiahAmount(value, decimals = 2) {
  return formatAmount(value, decimals, '.', ',');
}
